import YYTree from './tree';

export default YYTree;